import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { Form, InputGroup } from 'react-bootstrap';
import log from '../../../utils/log';

class TextInput extends Component {
    static propTypes = {
        placeholder: PropTypes.string,
        showBottomBorder: PropTypes.bool,
        value: PropTypes.string,
        onChange: PropTypes.func,
        onClear: PropTypes.func,
        onSubmit: PropTypes.func,
        disabled: PropTypes.bool,
        required: PropTypes.bool,
        type: PropTypes.string,
        componentClass: PropTypes.string,
        maxLength: PropTypes.string,
        name: PropTypes.string,
        input: PropTypes.any,
        rows: PropTypes.number
    };

    handleClear = () => {
        const { value } = this.props;

        if (this.props.onClear) {
            this.props.onClear(value);
        }
    };

    handleSubmit = () => {
        if (this.props.onSubmit) {
            this.props.onSubmit();
        }
    };

    render() {
        const {
            value = '',
            disabled = false,
            required = false,
            type = 'text',
            input,
            showBottomBorder = true
        } = this.props;
        if (input) {
            log.error(
                'Input property is being passed into the SearchTextInput.  This functionality has been deprecated.'
            );
        }

        return (
            <InputGroup className={'col-12 searchTextInput'}>
                <span className={'frontcap'} />
                <i className={cns('fa', 'fa-fw', 'left-icon', { 'fa-search': !value }, { 'fa-times-circle': value })} /> 
                <Form.Control
                    as={this.props.componentClass}
                    className={cns({ 'searchbox-noBorder': !showBottomBorder })}
                    onChange={this.props.onChange}
                    value={value}
                    disabled={disabled}
                    required={required}
                    placeholder={this.props.placeholder}
                    rows={this.props.rows}
                    type={type}
                    maxLength={this.props.maxLength}
                    name={this.props.name}
                />
            </InputGroup>
        );
    }
}

export default TextInput;
